import React, { useState } from "react";
import { IoEyeOff, IoEye } from "react-icons/io5";
import CurrencyInput from "../CurrencyInput";
import * as S from "./styles";

const InputText = ({
  label,
  type,
  required,
  name,
  width,
  mask,
  currency = "false",
  error,
  currentType,
  inputType,
  iconComponent,
  ...rest
}) => {
  const [passwordShown, setPasswordShown] = useState(true);
  const togglePasswordVisiblity = () => {
    setPasswordShown(!passwordShown);
  };

  currency === "false" || currency === ""
    ? (currency = true)
    : (currency = false);

  return inputType === "password" ? (
    <div>
      <S.Container width={width}>
        <S.Input
          name={name}
          mask={mask}
          autoComplete={"off"}
          required={required && required}
          type={passwordShown ? "password" : "text"}
          {...rest}
          placeholder="nao remove esse place"
        />
        <S.Label error={error}>
          <span className="content__name">{label}</span>
        </S.Label>

        <S.Wrapper onClick={() => togglePasswordVisiblity()}>
          {passwordShown ? (
            <IoEye color="#00a2e0" size="35px" />
          ) : (
            <IoEyeOff color="#00a2e0" size="35px" />
          )}
        </S.Wrapper>
      </S.Container>
    </div>
  ) : (
    <S.Container width={width}>
      {currency ? (
        currentType && currentType === "cpf/cnpj" ?
          (
            <S.InputCPFCNPJ
              name={name}
              required={required}
              autoComplete={"off"}
              type={type}
              {...rest}
              placeholder="nao remove esse place"
            />
          ) : (
            <S.Input
              name={name}
              mask={mask}
              required={required}
              autoComplete={"off"}
              type={type}
              {...rest}
              placeholder="nao remove esse place"
            />
          )
      ) : (
        <CurrencyInput
          name={name}
          required={required}
          autoComplete={"off"}
          type={type}
          {...rest}
          placeholder="nao remove esse place"
          className="input"
        />
      )}
      <S.Label error={error}>
        <span className="content__name">{label}</span>
      </S.Label>
      {iconComponent ? <S.Wrapper>{iconComponent}</S.Wrapper> : <></>}
    </S.Container>
  );
};

export default InputText;
